module.exports = __WEBPACK_EXTERNAL_MODULE__angular_animations__;